<template>
  <v-flex xs12 sm10 md10 lg8>
    <v-card class="elevation-4 pa-3">
      <v-card-text class="mt-0 pt-0">
        <v-layout align-baseline row>
          <img
            src="@/assets/logo-120x120.png"
            :alt="sistem.app_title"
            height="25"
          />
          <h1
            class="mb-3 display-1 font-weight-regular"
            :class="`${sistem.app_theme}--text`"
          >
            Kebijakan Privasi
          </h1>
        </v-layout>
        <div v-html="sistem.privacy_policy" class="text-xs-justify"></div>
      </v-card-text>
      <v-card-actions>
        <public-menus></public-menus>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState } from "vuex";
import PublicMenus from "@/components/public/PublicMenus";

export default {
  name: "kebijakan-privasi",
  components: {
    PublicMenus
  },
  computed: {
    ...mapState("sistem", ["sistem"])
  }
};
</script>
